module.exports = "td{\r\n    border: 1px solid #ddd;\r\n}\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/allocation/pr-allotment/property-plan-alllist/property-plan-alllist.component.css
// module id = ./src/app/allocation/pr-allotment/property-plan-alllist/property-plan-alllist.component.css
// module chunks = main